export const STACK = {
    HOME: "/app",
    SEARCH: "/app/search",
    MYPAGE: "/app/mypage",
    LIMITED: "/app/limited",
    CART: "/app/cart",
    NOTIFICATION: "/app/notification"
}